export default (file:File): string => {const arrVars = file.name.split("."); arrVars.pop(); return arrVars.join(".")};
